module.exports = __webpack_public_path__ + "img/vip_wenb.60ee0073.svg";